import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import MutationKeys from 'hooks/mutations/keys';
import QueryKeys from 'hooks/queries/keys';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import type { PatchUserDisplayNameApiResponse, PatchUserDisplayNameInput } from 'domains/accessCentre/types';

/** PATCH /users/:userId — update display name (allowed when tenant is not platform-integrated). */
const usePatchUserDisplayName = (
    userId: string,
    mutateOptions?: UseMutationOptions<PatchUserDisplayNameApiResponse, Error, PatchUserDisplayNameInput>
) => {
    const queryClient = useQueryClient();
    const path = `${CuredApiPaths.ACCESS_CENTRE_USERS}/${userId}`;

    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<PatchUserDisplayNameInput, PatchUserDisplayNameApiResponse>(
        MutationKeys.PATCH_USER_DISPLAY_NAME(userId),
        path,
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(QueryKeys.ACCESS_CENTRE_USER_ID(userId));
                queryClient.invalidateQueries(['access-centre', 'users']);
                queryClient.invalidateQueries(QueryKeys.ACCESS_CENTRE_ME());
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.PATCH
    );
};

export default usePatchUserDisplayName;
